import React from "react";
import { MedicationGroup } from "components";
import { casesActions } from "configs";
import { useDispatch, useCurrentCase, UpdateCardProps } from "duck";
import { useUpdateSuspensionMutation } from "requests";
import { Create } from "./components";
import { useDeleteSuspension } from "./duck";

const Suspensions: React.FC = () => {
  const dispatch = useDispatch();
  const { suspensions, caseId, patientId, shouldSync } = useCurrentCase(
    medicalCase => ({
      suspensions: medicalCase.data.client.patient.suspensions,
      caseId: medicalCase.data._id,
      patientId: medicalCase.data.client.patient._id,
      shouldSync: medicalCase.shouldSync
    })
  );

  const onDelete = useDeleteSuspension();
  const [update] = useUpdateSuspensionMutation();
  const updateSuspension = React.useCallback((data: UpdateCardProps) => {
    const { idOrFakeId, ...variables } = data;

    if (shouldSync) {
      dispatch(
        casesActions.updateSuspension({
          _id: caseId,
          data: {
            ...(typeof idOrFakeId === "number"
              ? { _id: idOrFakeId }
              : { fakeId: idOrFakeId }),
            ...variables
          }
        })
      );
      if (typeof idOrFakeId === "number") {
        return update({
          variables: { input: { _id: idOrFakeId, ...variables } }
        });
      }
    }

    dispatch(
      casesActions.updateSuspension({
        _id: caseId,
        data: {
          ...(typeof idOrFakeId === "number"
            ? { _id: idOrFakeId }
            : { fakeId: idOrFakeId }),
          ...variables
        }
      })
    );
  }, []);

  return (
    <MedicationGroup.Provider update={updateSuspension}>
      <MedicationGroup
        groupName="Suspensions and Solutions"
        medications={suspensions}
        create={<Create patientId={patientId} />}
        onDelete={onDelete}
        allowCardToggle={false}
        medicationType="suspension"
      />
    </MedicationGroup.Provider>
  );
};

export default Suspensions;
